import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Card, Badge, Button } from "react-bootstrap";
import { HiOutlinePencil, HiOutlineTrash } from "react-icons/hi";
import "./MyPostCard.css";
const getStatusVariant = status => {
  switch (status) {
    case "Active":
      return "success";
    case "Inactive":
      return "secondary";
    case "Pending":
      return "warning";
    case "Rejected":
      return "danger";
    default:
      return "secondary";
  }
};
export default function MyPostCard({
  listing,
  onEdit,
  onDelete
}) {
  useLanguage();
  return <Card className="bb-my-post-card h-100">
      <div className="bb-my-post-card__image-wrap">
        <img src={listing.image || "https://via.placeholder.com/600x400?text=BaytBuddy+Room"} alt={listing.title} className="bb-my-post-card__image" />

      </div>

      <Card.Body className="d-flex flex-column">
        <div className="bb-my-post-card__top">
          <Badge bg={getStatusVariant(listing.status)}>{t(listing.status)}</Badge>
          <span className="bb-my-post-card__date">{t(listing.createdAt)}</span>
        </div>

        <h5 className="bb-my-post-card__title">{listing.title}</h5>

        <p className="bb-my-post-card__location">
          {t(listing.district)}, {t(listing.city)}
        </p>

        <div className="bb-my-post-card__meta">
          <span>{t(listing.type)}</span>
          <span>{t(listing.houseType)}</span>
          <span>{t(listing.furnished)}</span>
        </div>

        <h6 className="bb-my-post-card__price">{t("SAR ")}{t(listing.price)}{t(" / month")}</h6>

        <div className="bb-my-post-card__actions mt-auto">
          <Button variant="outline-primary" className="w-100 bb-brand-btn-outline" onClick={() => onEdit(listing)}>

            <HiOutlinePencil className="me-2" />{t("Edit")}

          </Button>

          <Button variant="outline-danger" className="w-100" onClick={() => onDelete(listing)}>

            <HiOutlineTrash className="me-2" />{t("Delete")}

          </Button>
        </div>
      </Card.Body>
    </Card>;
}
